export const areas = (state) => state.areas;
export const datagroups = (state) => state.datagroups;
export const packdata = (state) => state.packdata;
export const packcollection = (state) => state.packcollection;

export const menuoptions = (state) => {
    var array=state.areas.slice()
    array.unshift({ name: 'Areas', $isDisabled: true })
    array.unshift({ name: 'INICIO',id:"1" })
    return array;
};


export const actualBranchId = (state) => state.actualBranchId;
export const actualBranch = (state) => state.actualBranch;
export const actualArea = (state) => state.actualArea;
export const board = (state) => state.board;
export const allBoards=(state)=> state.allBoards;
export const allPipelines=(state)=> state.allPipelines;
export const currentUser=(state)=>state.currentUser;
export const roleName=(state)=>{
    return state.currentUser.cachedroleIn;
};
export const allowEdit=(state)=>{
    if(state.currentUser.cachedBusinessId){
        if('owner|master|manager'.indexOf(state.currentUser.cachedroleIn)+1){
            return true;
        }
        return false;
    }
    return true;
};

export const allBusiness=(state)=>state.allBusiness;
export const allTeams=(state)=>state.allTeams;
export const allBranchs=(state)=>state.allBranchs;
export const actualTeam=(state)=> state.actualTeam;
export const business=(state)=> state.business;
export const members=(state)=> state.members;
export const notifications=(state)=> state.notifications;
export const integrationsHub=(state)=> state.integrationsHub;
export const operators=(state)=> state.operators;

export const sharelinkdetail=(state)=> state.sharelinkdetail;
export const targets=(state)=> state.targets;
export const colortags=(state)=> state.colortags;

export const currentProxycard=(state)=> state.currentProxycard;



export const integrations=(state)=> state.integrations;

export const integrationsFb=(state)=>{
    var filterList=state.integrations.filter(item=>{
        if(item.category=='facebook-fanpagepub'){
            return item;
        }
    })
    return filterList;
}

export const schemeList=(state)=> state.schemeList
export const actualScheme=(state)=> state.actualScheme

//FLUJO DE MODALS
export const actualPipeline=(state)=> state.actualPipeline
export const activeColumnModal=(state)=> state.activeColumnModal
